import React from 'react';
import './TimelineItem.css';
import Tag from './Tag'; // Importe le composant Tag depuis Tag.js ou Tag.jsx

const TimelineItem = ({ item }) => {
  return (
    <div className="timeline-item">
      <div className="timeline-content">
        <h3>{item.title}</h3>
        {item.image && <img src={item.image} alt={item.title} className="timeline-image" />}
        <p>{item.shortdescription}</p>
        <p>{item.place}</p>
        <div className="timeline-tags">
          {item.tags && item.tags.map((tag, index) => (
            <Tag key={index} text={tag} /> // Utilise le composant Tag pour afficher chaque tag
          ))}
        </div>
      </div>
    </div>
  );
};

export default TimelineItem;
